const XML_PARSER = new DOMParser()

export const xmlParser = (rawXml) =>
  XML_PARSER.parseFromString(rawXml, 'text/xml')

export const stringifyXml = (xml) => new XMLSerializer().serializeToString(xml)
